import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEn from "../i18n/locales/en.json";
import translationAr from "../i18n/locales/ar.json";
import { getDirection } from "./direction";

export const AR_LANG = "ar";
export const EN_LANG = "en";
export const SUPPORTED_LANGUAGES = [AR_LANG, EN_LANG];
const resources = {
  en: {
    translations: translationEn,
  },
  ar: {
    translations: translationAr,
  },
};

const syncDocumentLanguageAttributes = (language: string) => {
  document.documentElement.dir = getDirection(language);
  document.documentElement.lang = language;
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    defaultNS: "translations",
    debug: true,
    fallbackLng: EN_LANG,
    supportedLngs: SUPPORTED_LANGUAGES,
    resources,
    // Only a language the user explicitly switched to (persisted here) should override the
    // English/LTR default — ignore the browser/OS locale (navigator) so the app never opens
    // in Arabic just because the device is set to Arabic.
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  })
  .then(() => syncDocumentLanguageAttributes(i18n.language));

i18n.on("languageChanged", syncDocumentLanguageAttributes);

export default i18n;
